import { Card } from "react-bootstrap";
import React from "react";
import Image from "../general/image";
import { SubmitButton } from "react-dropzone-uploader";
import Icon from "../general/icon";

interface ISakhadDataTypeCard {
  titleIcon: any;
  title: string;
  subTitle: string;
  active?: boolean;
  icon?: any;
  onClick?: () => void;
}

const SakhadDataTypeCard: React.FC<ISakhadDataTypeCard> = ({
  titleIcon,
  title,
  subTitle,
  active,
  icon,
  onClick,
}) => (
  <Card
    className="w-100 h-100 border-light-blue cursor-pointer box-shadow cur-pointer"
    onClick={onClick}
  >
    <Card.Body className="d-flex justify-content-between align-items-center">
      <div className="d-flex">
        <div>
          <span className="d-inline-flex font-25 ms-2 ps-2">
            <Icon name={icon} />
            {/* <Image src="D:\source\AbrSalamat\git\salamat-panel\saairan-panel\src\assets\images\svg\cigarettes.svg" /> */}
          </span>
        </div>
        <div className="d-flex flex-column justify-content-center gap-3">
          <Card.Title className="font-12 font-weight-semibold">
            دریافت اطلاعات مربوط به {title}
          </Card.Title>
          <Card.Text
            className={`font-10 font-weight-medium ${
              !active ? "text-gray3" : " text-black"
            }`}
          >
            {subTitle}
          </Card.Text>
        </div>
      </div>
      <div>
        <button
          type="submit"
          disabled={!active}
          className={`btn btn-primary rounded d-flex align-items-center me-2 px-5 py-2 ${
            !active ? "opacity-50" : ""
          }`}
        >
          دریافت
        </button>
      </div>
    </Card.Body>
  </Card>
);
export default SakhadDataTypeCard;
